/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsGasPump: {
  name: 'gas-pump';
  data: string;
} = {
  name: 'gas-pump',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 0 0-2 2v16H3a1 1 0 1 0 0 2h2a.997.997 0 0 0 .411-.088A2 2 0 0 0 6 22h10c.205 0 .403-.03.589-.088A.997.997 0 0 0 17 22h4a1 1 0 1 0 0-2h-3V4a2 2 0 0 0-2-2H6Zm10 4V4H6v2h10ZM6 8h10v4H6V8Zm0 12v-6h10v6H6ZM22 7a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V7Z" fill="currentColor"/></svg>`,
};
